"use strict";

import React from "react";
import Label from "./label.js";
import { useContext, useState, useLayoutEffect, useRef } from "react";
import { SchemeContext } from "./scheme.js";
import { calculateRequiredRows } from "./utils.js";

function Prompt(props) {
    const scheme = useContext(SchemeContext);
    const [isMyInputFocused, setIsMyInputFocused] = useState(false);
    const inputRef = useRef(null);
    let classNames = "prompt";
    let bgcolour;
    let colour;
    // Add french short names for Quebec
    const EN_MONTH_NAMES_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const FR_MONTH_NAMES_SHORT = ['JAN', 'FEV', 'MAR', 'AVR', 'MAI', 'JUN', 'JUL', 'AOU', 'SEP', 'OCT', 'NOV', 'DEC'];
    const getConfigLanguage = () => {
        if (typeof WD !== "undefined") {
            const configLanguage = WD?.language;
            if (configLanguage) {
                return String(configLanguage).toLowerCase();
            }
        }
        return "en";
    };
    const monthNamesShort = getConfigLanguage() === "fr" ? FR_MONTH_NAMES_SHORT : EN_MONTH_NAMES_SHORT;
    var WDDatePickerOpts = {
        showOn: "button",
        buttonText: "",
        changeYear: true,
        changeMonth: true,
        yearRange: '1910:2050',
        buttonImage: approot + "static/wdres/calendar.svg",
        buttonImageOnly: true,
        onSelect: function (dateText) {
            WD.updateelement(null, this, dateText);
        },
        dateFormat: "dd M y",
        monthNamesShort: monthNamesShort
    };

    const realprompt =
        props.prompt.prompttype == "X" ||
        (props.prompt.prompttype != "M" &&
            props.prompt.datarow >= 0 &&
            props.prompt.datarow <= props.screenendrow &&
            props.prompt.datacol >= 0);
    const isradiobutton = (props.prompt.edittype == "RADIO-BUTTON" ||
        props.prompt.edittype == "RADIO.BUTTON" ||
        props.prompt.edittype == "RADIOBTN");
    const ischeckbox = (props.prompt.edittype == "CHECKBOX");
    const isdisabled = (isradiobutton && (props.prompt.prompttype === "S") ||
        (ischeckbox && props.prompt.prompttype == "S" && props.gridcontrol == "") ||
        (!ischeckbox && !isradiobutton && props.prompt.prompttype == "S"))
    const decodedValue = decodeURIComponent(props.prompt.value);

    if (isMyInputFocused && isdisabled) {
        // Handle a case where prompt gets disabled by host, 
        // blur doesn't trigger so the prompt thought it had focus even though it was disabled
        setIsMyInputFocused(false)
    }
    // Use the same tabIndex for all prompts in a grid. Once we're in there it works fine.
    // If we used prompt.name, focus jumps rows instead of columns, which we don't want
    // No tabindex for disabled fields
    const tabIndex = isdisabled ?
        "" :
        props.prompt.name.split("_")[0] + ('0000' +
            Number(props.grid ?
                props.gridfocus1.split("_")[1] :
                props.prompt.name.split("_")[1]
            )).slice(-4);
    if (props.prompt.bgcolour) {
        classNames += " bgcoloured";
    }
    if (props.grid && props.row % 2 && isdisabled) {
        bgcolour = 'rgba(0, 0, 0, 0.0)';
    } else if (isMyInputFocused) {
        bgcolour = scheme?.FOCUS?.colour;
    } else if (props.prompt.bgcolour) {
        bgcolour = props.prompt.bgcolour;
    } else if (isdisabled && !props.grid) {
        bgcolour = scheme?.SHOWFIELD?.colour;
    } else {
        bgcolour = scheme?.EDITABLE?.colour;
    }
    if (props.prompt.textcolour) {
        colour = props.prompt.textcolour;
    } else {
        colour = scheme?.TEXT?.colour;
    }
    if (props.grid) {
        classNames += " gridprompt";
    }
    if (props.prompt.textcolour) {
        classNames += " textcoloured";
    }
    if (props.prompt.tlb) {
        if (props.prompt.tlbicon.includes("/calendar.svg") && props.prompt.edittype != "PAY.DATE") {
            if (props.prompt.edittype == "DATE4") {
                classNames += " wdcalendar4";
            } else {
                classNames += " wdcalendar";
            }
        } else if (props.prompt.tlbleft) {
            classNames += " tlbleft";
        } else {
            classNames += " tlbright";
        }
    }
    if (props.prompt.justification == "R") {
        classNames += " rightjustified";
    }
    if (!ischeckbox && props.prompt.checkbox) {
        classNames += " checkboxlabel"
    }

    // Determine if this is a calendar field
    const isCalendar = props.prompt.tlb &&
        props.prompt.tlbicon.includes("/calendar.svg") &&
        props.prompt.edittype != "PAY.DATE";
    const isDate4 = isCalendar && props.prompt.edittype == "DATE4";

    // Initialize datepicker for calendar fields when component mounts or updates.
    useLayoutEffect(() => {
        if (inputRef.current && isCalendar) {
            // Check if datepicker already initialized to avoid re-initializing
            if (!window.jQuery(inputRef.current).hasClass("hasDatepicker")) {
                if (isDate4) {
                    window.jQuery(inputRef.current).datepicker({
                        ...WDDatePickerOpts,
                        dateFormat: "dd M yy"
                    });
                } else {
                    window.jQuery(inputRef.current).datepicker(WDDatePickerOpts);
                }
            }
        }

        // Cleanup function to destroy datepicker when component unmounts
        return () => {
            if (inputRef.current && window.jQuery(inputRef.current).hasClass("hasDatepicker")) {
                window.jQuery(inputRef.current).datepicker("destroy");
            }
        };
    }, [isCalendar, isDate4]);

    let label;
    let prompt;

    function renderRadioButton(rbitem, index, props) {
        //This function is used in Radio Button Condition.
        //It is developed to resolve code duplication.
        return (
            <span key={index} className="inputset">
                <input
                    type="radio"
                    id={`${props.prompt.name}_${rbitem[0]}`}
                    name={props.prompt.name}
                    tabIndex={tabIndex}
                    value={rbitem[0]}
                    disabled={isdisabled}
                    checked={rbitem[0] === decodedValue}
                    onChange={() => { }}
                    className="prompt"
                />
                <label htmlFor={`${props.prompt.name}_${rbitem[0]}`} className="rblabel" style={{ marginLeft: "3px" }}>
                    {rbitem[1]}
                </label>
                {props.prompt.radiobuttonposition === "VERTICAL" && <br />}
            </span>
        );
    }

    if (realprompt) {
        if (!props.grid && props.prompt.edittype !== "CHECKBOX") {
            label = (
                <Label
                    grid={false}
                    name={props.prompt.name}
                    top={props.prompt.labeltop}
                    left={props.prompt.labelleft}
                    tag={props.prompt.labeltag}
                />
            );
        }
        if (props.prompt.displaywidth <= 0) {
        } else if (isradiobutton) {
            if (props.prompt.radiobuttonposition === "VERTICAL") {
                prompt = (
                    <span className="promptcontainer"
                        id={props.prompt.name}
                        style={{
                            top: props.prompt.top,
                            left: props.prompt.left,
                        }}>
                        {props.prompt.radiobuttonitems.map((rbitem, index) => (
                            renderRadioButton(rbitem, index, props)
                        ))}
                    </span>
                );
            } else if (props.prompt.radiobuttonposition === "MANUAL") {
                prompt = (
                    <span id={props.prompt.name}>
                        {props.prompt.radiobuttonitems.map((rbitem, index) => (
                            <span className="promptcontainer"
                                style={{
                                    top: props.prompt.manual_top[index],
                                    left: props.prompt.manual_left[index],
                                    paddingTop: "2px",
                                }}
                                key={index}
                            >
                                {renderRadioButton(rbitem, index, props)}
                            </span>
                        ))}
                    </span>
                );
            }
        } else if (
            props.grid && (
                props.prompt.edittype == "WP" ||
                props.prompt.edittype == "WORDWRAP" ||
                props.prompt.edittype == "SCH.SCHEDULE"
            )
        ) {
            // For readonly (S) prompts, render only the text div, not a textarea
            if (props.prompt.prompttype == "S") {
                prompt = (
                    <div
                        className="promptcontainer promptreadonly"
                        style={{
                            left: "",
                            top: "",
                            width: "",
                        }}
                    >
                        <div className="prompttext">
                            {decodedValue.replaceAll(/\r\n/g, "\n").replaceAll(/\r/g, "\n")}
                        </div>
                    </div>
                );
            } else {
                // For editable prompts, render textarea
                prompt = (
                    <div
                        className="promptcontainer"
                        style={{
                            left: "",
                            top: "",
                            width: "",
                        }}
                    >
                        <textarea
                            ref={inputRef}
                            onDragStart={(e) => e.preventDefault()}
                            draggable="false"
                            readOnly={isdisabled}
                            className={classNames}
                            data-orig={decodedValue}
                            data-promptliteral={props.prompt.promptliteral}
                            style={{
                                overflow: "hidden",
                                backgroundColor: bgcolour,
                                color: colour,
                            }}
                            id={props.prompt.name}
                            maxLength="4096"
                            name={props.prompt.name}
                            tabIndex={tabIndex}
                            rows={calculateRequiredRows(props.prompt, props.gridwidth)}
                            value={decodedValue}
                            onChange={(e) =>
                                props.setValue(
                                    props.gridindex,
                                    props.row,
                                    props.col,
                                    e.target.value
                                )
                            }
                            onBlur={() => setIsMyInputFocused(false)}
                            onFocus={() => setIsMyInputFocused(true)}
                        />
                    </div>
                );
            }
        } else if (ischeckbox) {
            prompt = (
                <span
                    className="promptcontainer"
                    style={{
                        top: props.prompt.top,
                        left: props.prompt.left,
                        width: (props.grid ? props.prompt.width : ""),
                    }}>
                    <input
                        type="checkbox"
                        disabled={isdisabled}
                        checked={decodedValue == props.prompt.checkedvalue}
                        data-checkedvalue={props.prompt.checkedvalue}
                        data-uncheckedvalue={props.prompt.uncheckedvalue}
                        name={props.prompt.name}
                        id={props.prompt.name}
                        tabIndex={tabIndex}
                        onChange={(event) => {
                            if (props.grid) {
                                // Sync Grid._selectedrow via WDD ROW before the value reaches
                                // the host, so WC:QUERYROW answers with the clicked row
                                // (row clicks do this in ssprocessclick; direct checkbox
                                // clicks bypass that path)
                                const tr = event.target.closest("tr");
                                if (tr && tr.dataset.promptno && tr.dataset.row) {
                                    WD.input(WD.ESCAPE + "WDD" + WD.AM + "ROW" + WD.AM +
                                        tr.dataset.promptno + WD.AM + tr.dataset.row, true);
                                }
                                if (!WD.focused(props.gridfocus2) && !WD.focused(props.gridfocus1)) {
                                    WD.senddata(WD.getjump(props.prompt.name));
                                }
                                WD.updateelement(event, event.target, props.prompt.rowpos);
                                event.stopPropagation();
                                return false;
                            }
                        }}
                        onFocus={(event) => {
                            if (!props.grid) {
                                WD.focuselement(event, event.target.id);
                            }
                        }}
                        onClick={(event) => {
                            if (props.grid) {
                                event.stopPropagation();
                                return;
                            }
                            WD.updateelement(event, event.target);
                            return false;
                        }}
                        className="prompt"
                        value={props.prompt.value}
                    />
                    {!props.grid && (
                        <label htmlFor={props.prompt.id} className="rblabel" style={{ marginLeft: "3px" }}>
                            {props.prompt.labeltag}
                        </label>
                    )}
                </span>
            )
        } else if (props.prompt.edittype == "BROWSER") {
            let style = { position: "absolute" };
            let iframestyle = {};
            if (props.prompt.fullscreen) {
                style.bottom = 0;
                style.left = 0;
                style.right = 0;
                style.top = 0;
                iframestyle.border = 0;
                //TODO: check config.product somehow?
                iframestyle.marginTop = "-3px";
            } else {
                style.left = props.prompt.left;
                style.top = props.prompt.top;
                style.height = props.prompt.height;
                style.width = props.prompt.width;
            }
            let src = decodedValue;
            if (
                props.prompt.cmd == "login" &&
                src !== "about:blank" &&
                src !== ""
            ) {
                src = "..\\" + src;
            }
            prompt = (
                <div id={props.prompt.name} style={style}>
                    <iframe
                        className="screenbrowser"
                        style={iframestyle}
                        src={src}
                        onLoad={(e) =>
                            WD.updateiframefunctions(e.currentTarget)
                        }
                    ></iframe>
                    <script>
                        setTimeout(WD.updateiframefunctions($("#
                        {props.prompt.name} iframe").get(0)),100);
                    </script>
                </div>
            );
        } else {
            prompt = (
                <div
                    className="promptcontainer"
                    style={{
                        left: props.grid ? "" : props.prompt.left,
                        top: props.grid ? "" : props.prompt.top,
                        width: props.grid ? "" : props.prompt.width,
                    }}
                    title={
                        props.prompt.edittype !== "PASSWORD"
                            ? decodedValue
                            : ""
                    }
                >
                    <input
                        ref={inputRef}
                        autoComplete="off"
                        data-lpignore="true"
                        data-1p-ignore
                        data-bwignore="true"
                        data-form-type="other"
                        className={classNames}
                        data-list={
                            props.prompt.aclistname
                                ? props.prompt.aclistname
                                : undefined
                        }
                        data-orig={props.prompt.value}
                        data-promptliteral={props.prompt.promptliteral}
                        disabled={isdisabled}
                        draggable="false"
                        id={props.prompt.name}
                        tabIndex={tabIndex}
                        maxLength={props.prompt.maxlength}
                        name={props.prompt.name}
                        readOnly={
                            props.prompt.edittype == "PASSWORD" &&
                            props.prompt.prompttype !== "S"
                        }
                        style={{
                            width: props.prompt.tlb
                                ? "calc(100% - 1.5em )"
                                : "100%",
                            backgroundColor: bgcolour,
                            color: colour,
                        }}
                        title={
                            props.prompt.edittype !== "PASSWORD"
                                ? decodedValue
                                : ""
                        }
                        type={
                            props.prompt.edittype == "PASSWORD"
                                ? "password"
                                : "text"
                        }
                        value={decodedValue}
                        onChange={(e) =>
                            props.grid
                                ? props.setValue(
                                    props.gridindex,
                                    props.row,
                                    props.col,
                                    e.target.value
                                )
                                : props.setValue(props.index, e.target.value)
                        }
                        onBlur={() => setIsMyInputFocused(false)}
                        onFocus={() => setIsMyInputFocused(true)}
                    />
                    {props.prompt.tlb && (!props.prompt.tlbicon.includes("/calendar.svg") || props.prompt.edittype == "PAY.DATE") && (
                        <TLB
                            promptid={props.prompt.name}
                            tlbalt={props.prompt.tlbalt}
                            tlbicon={props.prompt.tlbicon}
                            tlbleft={props.prompt.tlbleft}
                        />
                    )}
                    
                </div>
            );
        }
    } else {
        prompt = (
            <div
                className="promptcontainer manualprompt"
                style={{ display: "none" }}
                name={props.prompt.name}
                id={props.prompt.name}
                title={props.prompt.title}
                data-edittype={props.prompt.edittype}
            >
                <span style={{ whiteSpace: "pre-line" }}>
                    {props.prompt.promptliteral}
                </span>
            </div>
        );
    }
    return (
        <>
            {label}
            {prompt}
        </>
    );
}

function TLB(props) {
    let classnames = "btn btn-primary wdtlb ";
    if (props.tlbleft) classnames += "tlbleft";
    else classnames += "tlbright";

    let imageclassnames = "";
    let imgalt = "";

    if (props.tlbicon.includes("/calendar.svg")) {
        imageclassnames = "wdtlbicon wdtlbcalendar";
        imgalt = props.tlbicon;
    } else if (!props.tlbicon.includes("/arrow_v_217bc0.svg")) {
        imageclassnames = "wdtlbicon wdtlbcusticon";
        imgalt = props.tlbicon;
    } else {
        imageclassnames = "wdtlbicon";
        imgalt = props.tlbalt;
    }

    return (
        <button
            className={classnames}
            tabIndex="-1"
            id={props.promptid + "_tlb"}
            name={props.promptid + "_tlb"}
            onClick={(e) => WD.firetlb(e, e.currentTarget)}
        >
            <img className={imageclassnames} src={props.tlbicon} alt={imgalt} />
        </button>
    );
}

export default Prompt;
